module.exports = __webpack_public_path__ + "img/robot-golem.db0e3106.svg";